import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@proget-shared/translate';

@Pipe({
  name: 'signalStrength',
})
export class SignalStrengthPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: number | string): string {
    const signalStrength: number = parseFloat(String(value));

    if (value === '' || !isFinite(signalStrength)) {
      return '';
    }

    return this.translateService.instant(this.getSignalStrengthLabelKey(signalStrength));
  }

  private getSignalStrengthLabelKey(signalStrength: number): string {
    if (signalStrength > -80) {
      return 'library.user_card.devices.list.signal_strength.great';
    }

    if (signalStrength > -90) {
      return 'library.user_card.devices.list.signal_strength.good';
    }

    if (signalStrength > -100) {
      return 'library.user_card.devices.list.signal_strength.average';
    }

    if (signalStrength > -110) {
      return 'library.user_card.devices.list.signal_strength.poor';
    }

    return 'library.user_card.devices.list.signal_strength.very_poor';
  }
}
